<h3>{{'USER.MODAL_TITLE' | translate}}</h3>
<form [formGroup]="changePasswordForm" (ngSubmit)="onSubmitForm(changePasswordForm.value)">
    <div class="inputForm">
        <mat-form-field appearance="fill">
            <mat-label>{{'USER.CURRENT_PASS' | translate}}</mat-label>
            <input matInput [type]="hide ? 'password' : 'text'" formControlName="formCurrentPassword">
            <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hide">
                <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
        </mat-form-field>
        <mat-form-field appearance="fill">
            <mat-label>{{'USER.NEW_PASS' | translate}}</mat-label>
            <input matInput [type]="hide1 ? 'password' : 'text'" formControlName="formNewPassword">
            <button mat-icon-button matSuffix (click)="hide1 = !hide1" [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hide1">
                <mat-icon>{{hide1 ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
        </mat-form-field>
        <mat-form-field appearance="fill">
            <mat-label>{{'USER.CONFIRM_NEW_PASS' | translate}}</mat-label>
            <input matInput [type]="hide2 ? 'password' : 'text'" formControlName="formConfirmNewPassword">
            <button mat-icon-button matSuffix (click)="hide2 = !hide2" [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hide2">
                <mat-icon>{{hide2 ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
        </mat-form-field>
    </div>
    <div *ngIf="showAdvice()" class="alert alert-warning">
        <strong>{{'USER.ATENTION' | translate}}</strong> {{'USER.PASS_ADVICE' | translate}}
    </div>
    <button mat-raised-button [mat-dialog-close]>{{'USER.CANCEL' | translate}}</button>
    <button mat-raised-button color="primary" class="right" [disabled]="validate()" [mat-dialog-close]="data"
        cdkFocusInitial type="submit">{{'USER.ACCEPT' | translate}}</button>
</form>